import { useEffect, useState } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Education from './components/Education';
import Services from './components/Services';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Pricing from './components/Pricing';
import { trackPageView } from './utils/analytics';

const normalize = (p) => p.replace(/\/+$/, '') || '/';

function App() {
  const [pathname, setPathname] = useState(
    typeof window !== 'undefined' ? normalize(window.location.pathname) : '/'
  );

  useEffect(() => {
    const onPop = () => setPathname(normalize(window.location.pathname));
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  const isPricing = pathname === '/pricing';

  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);

  return (
    <div className="App">
      <Navbar isPricing={isPricing} />
      {isPricing ? (
        <Pricing />
      ) : (
        <>
          <Hero />
          <About />
          <Skills />
          <Experience />
          <Education />
          <Services />
          <Projects />
          <Contact />
        </>
      )}
      <Footer />
    </div>
  );
}

export default App;
